// extracted by mini-css-extract-plugin
export var fadeInOut = "_4k-3";
export var icon = "_4k-4";
export var savedIndicator = "_4k-2";
export var savingIndicator = "_4k-0";
export var spin = "_4k-1";